import { Box, styled } from "@mui/material";

import {
    COLORS,
    TYPOGRAPHY,
} from "components/organisms/CreationModal/CreationModal.constants";

/** "──── or ────" separator between alternative ways of connecting. */
export const Divider = styled(Box)({
    display: "flex",
    alignItems: "center",
    gap: 12,
    margin: "20px 0",
    "&::before, &::after": {
        content: '""',
        flex: 1,
        height: 1,
        backgroundColor: COLORS.slate200,
    },
});

export const Label = styled("span")({
    flexShrink: 0,
    color: COLORS.slate400,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    ...TYPOGRAPHY.labelXs,
});
